import React from 'react';
import { Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Skeleton from '@/components/Skeleton';
import Text from '@/components/Text';
import { militaryTime } from '@/lib/date';

const TerminalTime = React.memo(
  ({
    loading = false,
    isNextDay = false,
    segmentTime,
    direction,
    locationCode,
  }) => (
    <Flex flexDirection="column" alignItems="flex-start">
      <Flex
        data-testid="TIME_AT_TERMINAL"
        alignItems="flex-end"
        justifyContent="center"
        bg={`${isNextDay ? 'background.warning' : ''}`}
      >
        <Text huge>
          <Skeleton visible={loading} width="85px">
            {() => militaryTime(segmentTime, 'h:mm')}
          </Skeleton>
        </Text>
        <Text ml="1" medium>
          <Skeleton visible={loading} width="25px">
            {() => militaryTime(segmentTime, 'a')}
          </Skeleton>
        </Text>
      </Flex>
      <Flex width={[null, null, '130px']}>
        <Text medium>
          <Skeleton visible={loading} width="35px">
            {() => locationCode}
          </Skeleton>
        </Text>
        <Text mx="1" medium>
          –
        </Text>
        <Text medium>
          <Skeleton visible={loading} width="75px">
            {() => direction}
          </Skeleton>
        </Text>
      </Flex>
    </Flex>
  ),
);

TerminalTime.propTypes = {
  loading: PropTypes.bool,
  isNextDay: PropTypes.bool,
  segmentTime: PropTypes.string,
  direction: PropTypes.string.isRequired,
  locationCode: PropTypes.string,
};

export default TerminalTime;
